module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/020-e46240475ae80121a9f912bad0c98528.jpg";